import { useCallback } from "react";

import StyledDialog from "../../../../common/components/dialog/StyledDialog";
import { useDialog } from "../../../../common/components/dialog/useDialog";
import EditIconButton from "../../../../common/components/icons/EditIconButton";
import { IFeedbackDetailsButtonProps } from "./AddFeedbackDetailsButton";
import FeedbackDetailsForm from "./FeedbackDetailsForm";

const EditEventFeedbackDetails = ({
  loading = false,
  mitigatedRisk = [],
  onSubmitClick,
}: IFeedbackDetailsButtonProps) => {
  const { open, handleDialogOpen, handleDialogClose } = useDialog();

  const memoizedSubmitCallback = useCallback(
    async (mitigatedRisk: string[]) => {
      await onSubmitClick(mitigatedRisk);

      handleDialogClose();
    },
    [mitigatedRisk]
  );

  return (
    <>
      <EditIconButton onClick={handleDialogOpen} showBorder={false} />

      <StyledDialog
        open={open}
        onClose={handleDialogClose}
        showSubmitButton={false}
        title="Mitigated Risk, Avoided Liabilities"
        subTitle="Select all applicable risks mitigated or liabilities avoided"
      >
        <FeedbackDetailsForm
          mitigatedRisk={mitigatedRisk}
          submitLoading={loading}
          onSubmitClick={memoizedSubmitCallback}
          onCancel={handleDialogClose}
        />
      </StyledDialog>
    </>
  );
};

export default EditEventFeedbackDetails;
